import { PropertyCategoryIdentifierEnum } from 'common/data/property-category/identifier.enum';

export const propertyReportGroupedReasons: {
  [category in PropertyCategoryIdentifierEnum]: {
    [userType: string]: number[];
  };
} = {
  [PropertyCategoryIdentifierEnum.residentialForSale]: {
    agent: [13, 1, 2, 9, 10],
    owner: [1, 9, 11, 10, 2],
    buyer: [1, 2, 3, 5, 9, 6, 10, 11],
  },
  [PropertyCategoryIdentifierEnum.residentialForRent]: {
    agent: [13, 1, 2, 9, 10],
    landlord: [1, 9, 11, 10, 2],
    renter: [1, 3, 5, 9, 6, 10, 11],
  },
  [PropertyCategoryIdentifierEnum.commercialForSale]: {
    agent: [13, 1, 2, 9, 10],
    owner: [1, 9, 11, 10, 2],
    buyer: [1, 2, 3, 5, 9, 6, 10, 11],
  },
  [PropertyCategoryIdentifierEnum.commercialForRent]: {
    agent: [13, 1, 2, 9, 10],
    landlord: [1, 9, 11, 10, 2],
    renter: [1, 2, 3, 5, 9, 6, 10, 11],
  },
};
